import { useMutation } from 'query';
import { deleteCurrentUser } from '../../services';

type RemoveUserAccountData = {
  deleteReason?: string;
};

export const useRemoveAccountMutation = () =>
  useMutation<unknown, RemoveUserAccountData>({
    async mutationFn({ deleteReason }) {
      const response = await deleteCurrentUser({ body: { reason: deleteReason } });
      return response.data;
    },
  });
